
export const store = {
	userd: {
		people: [{name: "You", age: 22, sex: "F"}],
		zip: "33134",
		people_num:1,
		income: 40000,
	}
}